import { svgPaths } from '../../imports/svgPaths';
// import.*from.*imports/svg-b7302w5m67";

interface BusinessProcessStepsProps {
  className?: string;
}

export function BusinessProcessSteps({ className = "" }: BusinessProcessStepsProps) {
  return (
    <div className={`[flex-flow:wrap] box-border content-start flex gap-4 items-start justify-start overflow-clip p-0 relative shrink-0 w-full ${className}`}>
      <div className="absolute h-0 left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] w-[900px]">
        <div className="absolute bottom-[-2px] left-0 right-0 top-[-2px]">
          <svg
            className="block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 900 4"
          >
            <path
              d="M0 2H900"
              id="Vector 5"
              stroke="var(--stroke-0, #DBDBDB)"
              strokeDasharray="4 2"
              strokeWidth="4"
            />
          </svg>
        </div>
      </div>

      {/* Step 1 */}
      <div className="basis-0 bg-[#ffffff] grow min-h-px min-w-px relative rounded-2xl shrink-0">
        <div
          aria-hidden="true"
          className="absolute border border-[#eaeaea] border-solid inset-0 pointer-events-none rounded-2xl"
        />
        <div className="relative size-full">
          <div className="box-border content-stretch flex flex-col gap-4 items-start justify-start p-[24px] relative w-full">
            <div className="bg-[#a5b629] box-border content-stretch flex flex-col gap-2.5 items-center justify-center p-0 relative rounded-[100px] shrink-0 size-12">
              <div className="relative shrink-0 size-6">
                <div className="absolute inset-[16.67%_8.33%_0.77%_8.33%]">
                  <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
                    <g id="Group">
                      <g id="Vector"></g>
                      <path
                        d={svgPaths.p1eaede00}
                        fill="var(--fill-0, #FAFAFA)"
                        id="Vector_2"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div className="box-border content-stretch flex flex-col gap-2 items-start justify-start leading-[0] not-italic p-0 relative shrink-0 text-left w-full">
              <div className="font-paperlogy font-medium relative shrink-0 text-[20px] text-neutral-950 tracking-[-0.4px] w-full">
                <p className="block leading-[normal]">1. 창업 상담</p>
              </div>
              <div className="font-paperlogy font-normal leading-[normal] relative shrink-0 text-[#666666] text-[16px] tracking-[-0.32px] w-full">
                <p className="block mb-0 text-[15px]">조건, 수익성을 고려한</p>
                <p className="block text-[15px]">전문적인 상담진행</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Step 2 */}
      <div className="basis-0 bg-[#ffffff] grow min-h-px min-w-px relative rounded-2xl shrink-0">
        <div
          aria-hidden="true"
          className="absolute border border-[#eaeaea] border-solid inset-0 pointer-events-none rounded-2xl"
        />
        <div className="relative size-full">
          <div className="box-border content-stretch flex flex-col gap-4 items-start justify-start relative w-full px-[18px] p-[24px]">
            <div className="bg-[#a5b629] box-border content-stretch flex flex-col gap-2.5 items-center justify-center p-0 relative rounded-[100px] shrink-0 size-12">
              <div className="relative shrink-0 size-6">
                <div className="absolute inset-[16.67%_8.33%_0.77%_8.33%]">
                  <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
                    <g id="Group">
                      <g id="Vector"></g>
                      <path
                        d={svgPaths.p1104ee00}
                        fill="var(--fill-0, #FAFAFA)"
                        id="Vector_2"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div className="box-border content-stretch flex flex-col gap-2 items-start justify-start leading-[0] not-italic p-0 relative shrink-0 text-left w-full">
              <div className="font-paperlogy font-medium relative shrink-0 text-[20px] text-neutral-950 tracking-[-0.4px] w-full">
                <p className="block leading-[normal]">2. 현장실사</p>
              </div>
              <div className="font-paperlogy font-normal leading-[normal] relative shrink-0 text-[#666666] text-[16px] tracking-[-0.32px] w-full">
                <p className="block mb-0 text-[15px]">입점점포의 현장상황을 확인해</p>
                <p className="block text-[15px]">최적의 콘텐츠 구성 및 방향 제시</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Step 3 */}
      <div className="basis-0 bg-[#ffffff] grow min-h-px min-w-px relative rounded-2xl shrink-0">
        <div
          aria-hidden="true"
          className="absolute border border-[#eaeaea] border-solid inset-0 pointer-events-none rounded-2xl"
        />
        <div className="relative size-full">
          <div className="box-border content-stretch flex flex-col gap-4 items-start justify-start p-[24px] relative w-full">
            <div className="bg-[#a5b629] box-border content-stretch flex flex-col gap-2.5 items-center justify-center p-0 relative rounded-[100px] shrink-0 size-12">
              <div className="relative shrink-0 size-6">
                <div className="absolute inset-[8.33%_16.67%_0.77%_16.67%]">
                  <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 16 22">
                    <g id="Group">
                      <g id="Vector"></g>
                      <path
                        d={svgPaths.p3587b900}
                        fill="var(--fill-0, #FAFAFA)"
                        id="Vector_2"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div className="box-border content-stretch flex flex-col gap-2 items-start justify-start leading-[0] not-italic p-0 relative shrink-0 text-left w-full">
              <div className="font-paperlogy font-medium relative shrink-0 text-[20px] text-neutral-950 tracking-[-0.4px] w-full">
                <p className="block leading-[normal]">{`3. 계약 & 교육`}</p>
              </div>
              <div className="font-paperlogy font-normal leading-[normal] relative shrink-0 text-[#666666] text-[16px] tracking-[-0.32px] w-full">
                <p className="block mb-0 text-[15px]">협의된 내용으로 계약 후</p>
                <p className="block text-[15px]">운영에 필요한 교육을 제공</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Step 4 */}
      <div className="basis-0 bg-[#ffffff] grow min-h-px min-w-px relative rounded-2xl shrink-0">
        <div
          aria-hidden="true"
          className="absolute border border-[#eaeaea] border-solid inset-0 pointer-events-none rounded-2xl"
        />
        <div className="relative size-full">
          <div className="box-border content-stretch flex flex-col gap-4 items-start justify-start p-[24px] relative w-full">
            <div className="bg-[#a5b629] box-border content-stretch flex flex-col gap-2.5 items-center justify-center p-0 relative rounded-[100px] shrink-0 size-12">
              <div className="relative shrink-0 size-6">
                <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
                  <g id="Group">
                    <g id="Vector"></g>
                    <path
                      clipRule="evenodd"
                      d={svgPaths.p395b2d80}
                      fill="var(--fill-0, #FAFAFA)"
                      fillRule="evenodd"
                      id="Vector_2"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div className="box-border content-stretch flex flex-col gap-2 items-start justify-start leading-[0] not-italic p-0 relative shrink-0 text-left w-full">
              <div className="font-paperlogy font-medium relative shrink-0 text-[20px] text-neutral-950 tracking-[-0.4px] w-full">
                <p className="block leading-[normal]">{`4. 인테리어 & 콘텐츠`}</p>
              </div>
              <div className="font-paperlogy font-normal leading-[normal] relative shrink-0 text-[#666666] text-[16px] tracking-[-0.32px] w-full">
                <p className="block mb-0 text-[15px]">인테리어와 함께</p>
                <p className="block text-[15px]">콘텐츠 및 장비 설치, 점검</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Step 5 */}
      <div className="basis-0 bg-[#ffffff] grow min-h-px min-w-px relative rounded-2xl shrink-0">
        <div
          aria-hidden="true"
          className="absolute border border-[#eaeaea] border-solid inset-0 pointer-events-none rounded-2xl"
        />
        <div className="relative size-full">
          <div className="box-border content-stretch flex flex-col gap-4 items-start justify-start p-[24px] relative w-full">
            <div className="bg-[#a5b629] box-border content-stretch flex flex-col gap-2.5 items-center justify-center p-0 relative rounded-[100px] shrink-0 size-12">
              <div className="relative shrink-0 size-6">
                <div className="absolute inset-[4.39%_10.42%_0.78%_11.72%]">
                  <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 19 23">
                    <g id="Group">
                      <g id="Vector"></g>
                      <path
                        d={svgPaths.p15023500}
                        fill="var(--fill-0, #FAFAFA)"
                        id="Vector_2"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div className="box-border content-stretch flex flex-col gap-2 items-start justify-start leading-[0] not-italic p-0 relative shrink-0 text-left w-full">
              <div className="font-paperlogy font-medium relative shrink-0 text-[20px] text-neutral-950 tracking-[-0.4px] w-full">
                <p className="block leading-[normal]">{`5. 오픈 & 운영 지원`}</p>
              </div>
              <div className="font-paperlogy font-normal leading-[normal] relative shrink-0 text-[#666666] text-[16px] tracking-[-0.32px] w-full">
                <p className="block mb-0 text-[15px]">오픈에 필요한 자료 제공 및</p>
                <p className="block text-[15px]">오픈 후에도 지속적으로 지원</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}